import "./Politicas.css";

export default function Privacidad() {
  return (
    <div className="politicas-container">
      <h1>Política de Privacidad</h1>

      <ul>
        <li>Recopilamos únicamente los datos necesarios para procesar pedidos.</li>
        <li>No compartimos información personal con terceros sin autorización.</li>
        <li>El cliente puede solicitar eliminación o actualización de sus datos.</li>
        <li>Los datos se almacenan de manera segura y cumplen la legislación colombiana vigente.</li>
      </ul>
    </div>
  );
}
